// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorSiteAccountUpsearchResponseModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorSiteAccountUpsearchResponseModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorSiteAccountUpsearchResponseModel.discriminator = undefined;
EnterpriseCoordinatorSiteAccountUpsearchResponseModel.additionalProperties = false;
EnterpriseCoordinatorSiteAccountUpsearchResponseModel.attributeTypeMap = [
    {
        "name": "partyId",
        "baseName": "partyId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": ""
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": ""
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": ""
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
];
//# sourceMappingURL=enterpriseCoordinatorSiteAccountUpsearchResponseModel.js.map